<template>
  <!-- @figma-override:add reason="구버전 앱 업데이트 안내 — 옛 빌드는 본인인증·결제가 앱 안에서 끝나지 않는다(W-09). 피그마 없음, 사용자 지시" date="2026-09-28" requester="goduk" registry="F-APP-UPD-01" -->
  <div
    v-if="visible"
    class="app-update-notice fixed left-0 right-0 top-0 z-[9999] bg-[#222222] text-white px-4 py-3 shadow-md"
    role="status"
  >
    <div class="max-w-[480px] mx-auto flex items-start gap-3">
      <p class="flex-1 text-[13px] leading-[19px]">
        이전 버전 앱을 사용 중입니다. 본인인증·결제가 앱 안에서 완료되지 않을 수 있어요.
        스토어에서 최신 버전으로 업데이트해 주세요.
      </p>
      <button
        type="button"
        class="shrink-0 h-[30px] px-3 rounded-[6px] bg-[#A0CC4F] text-[13px] font-bold text-white"
        @click="openStore"
      >
        업데이트
      </button>
      <button type="button" class="shrink-0 w-[24px] h-[30px] text-[18px] leading-none text-[#BBBBBB]" aria-label="닫기" @click="dismiss">
        ×
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
/**
 * 구버전 앱 안내 (2026-09-28)
 *
 * 왜 있나 — 고객사 테스트에서 «vc 27 인데 본인인증이 브라우저로 샌다» 는 신고의 실제 원인은
 * 설치된 앱이 8월 승인본(09-17 이전 빌드)이었던 것이다. 스토어 검토 전에는 공개 테스트·프로덕션이
 * 이전 승인본을 내려주고, 기기에서 버전을 구분하기 어렵다.
 * → 앱 WebView 인데 새 빌드 표식(UA `GCB-SNS-SESSION`, vc 27·iOS 7 이상)이 없으면 안내한다.
 *    웹 배포만으로 이미 나간 모든 앱에 뜬다. 세션당 한 번 닫으면 다시 뜨지 않는다.
 */
import { ref, onMounted } from 'vue'
import { isRunningInRNWebView, supportsSnsAuthSession } from '@/utils/rn-bridge'

const DISMISS_KEY = 'appUpdateNoticeDismissed'
const PLAY_URL = 'https://play.google.com/store/apps/details?id=com.golchongbi.app'
const APP_STORE_URL = 'https://apps.apple.com/app/id6772498318'

const visible = ref(false)

onMounted(() => {
  if (!isRunningInRNWebView() || supportsSnsAuthSession()) return
  try {
    if (sessionStorage.getItem(DISMISS_KEY) === 'Y') return
  } catch {
    /* v12-ok: sessionStorage 차단 — 안내는 그대로 보여 준다 */
  }
  visible.value = true
})

const dismiss = () => {
  visible.value = false
  try {
    sessionStorage.setItem(DISMISS_KEY, 'Y')
  } catch {
    /* v12-ok: 저장 실패 — 이번 화면에서만 닫힌다 */
  }
}

const openStore = () => {
  const ios = /iPhone|iPad|iPod|Macintosh/i.test(navigator.userAgent)
  // 구버전 앱은 외부 https 를 시스템 브라우저/스토어 앱으로 넘긴다
  window.location.href = ios ? APP_STORE_URL : PLAY_URL
}
</script>

<style>
/* 사진 크게 보기(ImageViewer)가 열려 있는 동안 숨긴다 — 이 띠(z 9999)가 뷰어(z 9000) 맨 위의 [저장]·[닫기]를
   덮었다(2026-10-09 운영 재현). 뷰어가 body 에 image-viewer-open 을 달고, 닫으면 다시 보인다. */
body.image-viewer-open .app-update-notice {
  display: none;
}
</style>
